import { Component } from 'vue';

export enum UniversalButtonColorType {
  Gradient = 'gradient',
  Monocolor = 'monocolor',
}

export enum UniversalButtonSizeType {
  Medium = 'medium',
  Large = 'large',
}

export interface UniversalButtonProps {
  backgroundOpacity?: number,
  backgroundColorRgba?: string,
  theme?: UniversalButtonColorType,

  fontSize?: string,
  title?: string,
  textColorRgba?: string,

  prefixIcon?: Component,
  suffixIcon?: Component
  iconSize?: UniversalButtonSizeType | number,

  block?: boolean,
  rounded?: boolean,
  height?: UniversalButtonSizeType | number,
  disabled?: boolean,

  target?: string,
  internalLink?: string,
  externalLink?: string,

  loading?: boolean,

  uppercase?: boolean,
  capitalize?: boolean,
  multiLine?: boolean, // allow to use multi line text
}
